module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_text_en.1785317263746.png";